import {CloseButton} from "@mantine/core";
import {useTranslation} from "react-i18next";
import {Dialog} from "./Dialog";
import {SendToDflowTab} from "./SendToDflowTab";
import type {CollectionMeta, ExportDocument, TopicMeta} from "./types";
import classes from "./generateModal.module.css";

type Props = {
    opened: boolean;
    onClose: () => void;
    topicMeta: TopicMeta;
    collectionMeta?: CollectionMeta;
    documents: ExportDocument[];
};

// Standalone Dflow path — no tabbed shell. Untested in ai-chat-frontend; no caller yet.
export const StandaloneDflowModal = ({
    opened,
    onClose,
    topicMeta,
    collectionMeta,
    documents,
}: Props) => {
    const {t} = useTranslation();
    return (
        <Dialog active={opened} onClose={onClose} data-pw="generate-dialog">
            <header className={classes.header}>
                <h2 className={classes.heading}>{t("Word.Generate")}</h2>
                <CloseButton
                    onClick={onClose}
                    aria-label={t("Action.Close", {defaultValue: "Close"})}
                />
            </header>
            <SendToDflowTab
                onClose={onClose}
                topicMeta={topicMeta}
                collectionMeta={collectionMeta}
                documents={documents}
            />
        </Dialog>
    );
};
